/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div class="item-position project-alarm">
    <div class="title-item">
      <div class="first"></div>
      <div class="two">03</div>
      <div class="title">
        <div>Real-time Data</div>
        <div>实时告警</div>
      </div>
    </div>
    <div class="alarm-title">
      <div :class="{'click':isRunInfo === 1}" @click="itemClick(1)">高危风险</div>
      <div :class="{'click':isRunInfo === 2}" @click="itemClick(2)">低危风险</div>
      <div :class="{'click':isRunInfo === 3}" @click="itemClick(3)">机体风险</div>
    </div>
    <div class="alarm-split" />
    <div class="alarm-content" v-if="isRunInfo === 1">
      <div class="info-item" v-for="(item,index) of behaviorHighDetail" :key="index">
        <div class="title" v-html="item.content"/>
        <div class="time">{{calcTime(item.recordTime)}}</div>
      </div>
    </div>
    <div class="alarm-content" v-if="isRunInfo === 2">
      <div class="info-item" v-for="(item,index) of behaviorLowDetail" :key="index">
        <div class="title" v-html="item.content"/>
        <div class="time">{{calcTime(item.recordTime)}}</div>
      </div>
    </div>
    <div class="alarm-content" v-if="isRunInfo === 3">
      <div class="info-item" v-for="(item,index) of bodyRiskDetail" :key="index">
        <div class="title" v-html="item.content" />
        <div class="time">{{calcTime(item.recordTime)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'statRiskDetail',
  data () {
    return {
      isRunInfo: 1
    }
  },
  props: {
    behaviorHighDetail: {
      type: Array
    },
    behaviorLowDetail: {
      type: Array
    },
    bodyRiskDetail: {
      type: Array
    }
  },
  methods: {
    itemClick (type) {
      this.isRunInfo = type
    },
    calcTime (timeStr) {
      let str = ''
      try {
        str = dayjs(timeStr).format('HH:mm:ss')
      } catch(e)  {

      }
      return str
    }
  }
}
</script>

<style scoped lang="scss">
  .project-alarm{
    z-index: 2;
    left: 10px;
    top: 566px;
    width: 355px;
    .alarm-title{
      display: flex;
      justify-content: space-between;
      color:rgba(255,255,255,0.3);
      div{
        flex: 1;
        height:26px;
        background-color: rgba(4,30,48,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        cursor:pointer;
      }
      .click{
        color: #15c5e8 !important;
        border-bottom:  1px solid #15c5e8 !important;
      }
    }
    .alarm-split{
      margin-top: 9px;
    }
    .alarm-content{
      background-color: rgba(4,30,48,0.5);
      width:100%;
      height:418px;
      font-size: 14px;
      margin-top: 6px;
      overflow: auto;
      .info-item{
        height:31px;
        width:100%;
        display: flex;
        align-items: center;
        padding:0 5px;
        color: #fff;
        .title{
          overflow:hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
          width:300px;
        }
        .time{
          width:108px;
          text-align: center;
        }
      }
      .info-item:nth-child(odd){
        background-color:rgba(8,43,65,0.5)
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StatRiskDetail.vue